const dropdown = (el, target) => { 
    const dropdown = document.getElementById(el)
    dropdown.addEventListener('click', e => dropdown.classList.toggle('active'))
}

if (document.getElementById('chart_dropdown')) { 
    dropdown('chart_dropdown')
    document.querySelector('#chart_dropdown button').classList.add('active')
    document.querySelector('.chart').classList.add('active')
}

